<template>
    <div class="modal">
        <div @click="$emit('close')" class="modalWrapper">
            <div class="modalContent">
                <div
                    @click.stop class="content"
                    :style="{
                      maxWidth: width
                    }"
                >
                    <i @click="$emit('close')" class="close"></i>
                    <slot></slot>
                    <button v-if="buttonText" @click="$emit('close')" class="btn">{{ buttonText }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            show: {
              type: Boolean
            },
            buttonText: {
                type: String
            },
            width: {
                type: String
            }
        },
        created() {
            document.body.style.setProperty('overflow', 'hidden');
        },
        destroyed() {
            document.body.style.removeProperty('overflow');
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../sass/base/mixins";

    .modal {
      overflow: hidden auto;
      position: fixed;
      box-sizing: border-box;
      left: 0;
      top: 0;
      width: 100%;
      height: 100vh;
      background: rgba(22,27,35,0.4);
      z-index: 999;

      .modalWrapper {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;

        &:before {
          content: '';
          display: inline-block;
          height: 100%;
          vertical-align: middle;
        }

        .modalContent {
            width: 100%;
            position: relative;
            display: inline-block;
            vertical-align: middle;
            margin: 0 auto;

            .content {
                position: relative;
                background: #FFF;
                padding: 20px;
                width: auto;
                max-width: 620px;
                margin: 20px auto;

                @include mobile {
                    padding: 35px 20px;
                    margin: auto;
                    text-align: left;
                }
            }

          i.close {
            width: 12px;
            height: 12px;
            background: url('/assets/img/close-blue.svg');
            position: absolute;
            top: 15px;
            right: 15px;
            cursor: pointer;
          }
        }
      }
    }
</style>